import Swiper from '../../../../../vendor/swiper/swiper-bundle.mjs';

export default class Hero {
    constructor($el) {
        this.$el = $el;
        this.$swiper = this.$el.querySelector('[data-hero-swiper]');

        this.initSlider = this.initSlider.bind(this);

        this.initSlider();
    }

    initSlider() {
        new Swiper(this.$swiper, {
            spaceBetween: 0,
            loop: true,
            autoplay: true,
            timeout: 5000,
            slidesPerView: 1,
            pagination: {
                el: '[data-hero-swiper-pagination]',
                bulletClass: 'hero__pagination__bullet',
                bulletActiveClass: 'hero__pagination__bullet--active',
                clickable: {
                    delay: 3000
                }
            }
        });
    }
}